<template>
  <sea-page title="Bacheca" header="Bacheca">
    <sea-page-content
      :fetchList="fetchList"
      :resetList="resetList"
      searchPanel
      searchType="data"
    >
      <template v-slot:table="{ attrs }">
        <v-data-table
          v-bind="attrs"
          :headers="headers"
          :items="items"
          disable-sort
          dense
          height="calc(100vh - 255px)"
          :expanded="expanded"
          item-key="id"
          @click:row="clicked"
        >
          <template v-slot:item.data="{ item }">
            {{ item.data | dateFormat }}
          </template>
          <template v-slot:item.letto="{ item }">
            <check-icon :checked="item.letto"></check-icon>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              elevation="2"
              rounded
              x-small
              @click.stop="clicked(item)"
              color="primary"
            >
              Dettaglio
              <v-icon right dark>mdi-cloud-download </v-icon>
            </v-btn>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              {{ item.testo }}
            </td>
          </template>
        </v-data-table>
      </template>
    </sea-page-content>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CheckIcon from "@/components/CheckIcon.vue";

const headers = [
  { text: "Data", value: "data", class: "head" },
  { text: "Descrizione", value: "titolo", class: "head" },
  { text: "Letto", value: "letto", class: "head" },
  { text: "", value: "actions", class: "head", align: "end" },
];

export default {
  components: { CheckIcon },
  data() {
    return {
      expanded: [],
      headers,
    };
  },
  methods: {
    ...mapActions({
      fetchList: "employee/fetchMyNotices",
      resetList: "employee/resetNotices",
      markRead: "employee/markRead",
    }),
    clicked(row) {
      const index = this.expanded.indexOf(row);
      if (index === -1) {
        this.expanded.length = 0;
        this.expanded.push(row);
        //sto aprendo la descrizione
        if (!row.letto) {
          this.markRead(row.id);
        }
      } else {
        this.expanded.splice(index, 1);
      }
    },
  },
  computed: {
    ...mapGetters({
      items: "employee/notices",
    }),
  },
};
</script>

<style>
/** */
</style>
